import { C14SidePhotoContentCardCarouselProps } from './C14SidePhotoContentCardCarousel.types';
import { SIDE_PHOTO_CONTENT_CARDS } from 'src/shared/static';
import { Text, Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { Container, SidePhotoContentCardCarousel } from '@ahc-digital/component-library';
import { CreateSidePhotoContentCardCarouselModel } from './C14SidePhotoContentCardCarousel.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C14SidePhotoContentCardCarouselProps) => {
  const phKey = SIDE_PHOTO_CONTENT_CARDS + `-${props?.params?.DynamicPlaceholderId}`;
  const { sitecoreContext } = useSitecoreContext();
  const { renderRichText, renderLink } = useConditionalRendering();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <>
      {isEditing ? (
        <div className="component-content">
          <strong>
            <i>
              **Note: Carousel rendering parameter updates will be visible on the rendered page**
            </i>
          </strong>
          <Container>
            <Text field={props?.fields?.Headline} />
            {renderRichText(props?.fields?.SupportCopy)}
          </Container>
          {props?.rendering && <Placeholder name={phKey} rendering={props?.rendering} />}
          <Container>
            {renderRichText(props?.fields?.SupportCopyBottom)}
            {renderLink(props?.fields?.CTA)}
          </Container>
        </div>
      ) : (
        <SidePhotoContentCardCarousel
          {...CreateSidePhotoContentCardCarouselModel(props)}
          id={props?.params?.AnchorLinkTargetName}
          className={translationClasses(props?.params)}
          data-component={marketingRenderingName}
        />
      )}
    </>
  );
};

export default checkDatasourceForRendering<C14SidePhotoContentCardCarouselProps>(Default);
